import React from "react";
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";

import {
  BranchEtaTable,
  SosEtaCreate,
  SosEtaList,
  SosEtaUpdate,
} from "./screens";

const ETARouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/sos/create`}>
        <SosEtaCreate />
      </Route>
      <Route path={`${path}/sos/:id`}>
        <SosEtaUpdate />
      </Route>
      <Route path={`${path}/sos`}>
        <SosEtaList />
      </Route>
      <Route path={`${path}/branches`}>
        <BranchEtaTable />
      </Route>
      <Route>
        <Redirect to={`${path}/sos`} />
      </Route>
    </Switch>
  );
};

export default ETARouter;
